// extracted by mini-css-extract-plugin
var _1 = "AIButtonText-moduleaiButtonText__hhww0";
var _2 = "AIButtonText-moduleaiButtonTextLabel__UEafF";
export { _1 as "aiButtonText", _2 as "aiButtonTextLabel" }
